import { KeyboardSensor, PointerSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { useSortable, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { C } from "./theme";

// The app's drag sensors (CLAUDE.md rule 4): 8px with a mouse, a 300ms hold on touch so a list still scrolls,
// and the keyboard (Space on ⠿ to pick up, arrows to move, Space to drop).
export const useDragSensors = () => useSensors(
  useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
  useSensor(TouchSensor, { activationConstraint: { delay: 300, tolerance: 5 } }),
  useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
);

// One draggable item for dnd-kit lists (Radar's groups, Goals, Tasks' categories, the Dreamboard, Fears, Mindset, Gratitude,
// and Habits and Temptations within each category).
// The render prop gets what a drag handle needs: spread `attributes` and `listeners` on the handle and
// pass `setActivatorNodeRef` as its ref, so only the ⠿ handle starts a drag. `style` adds to the wrapper.
export function Sortable({ id, style, children }) {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({ id });
  return (
    <div ref={setNodeRef} style={{ transform: CSS.Translate.toString(transform), transition, zIndex: isDragging ? 10 : undefined, ...style }}>
      {children({ isDragging, attributes, listeners, setActivatorNodeRef })}
    </div>
  );
}

// The ⠿ handle that starts a drag: spread Sortable's render-prop values onto it. `label` names what moves;
// `color` suits a handle on a coloured bar (the Goals page's goals).
export function DragHandle({ label, attributes, listeners, setActivatorNodeRef, color }) {
  return (
    <button ref={setActivatorNodeRef} {...attributes} {...listeners} aria-label={`Drag to reorder ${label}`}
      style={{ width: 44, height: 44, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "none", border: "none", color: color || C.textMid, fontSize: 20, cursor: "grab", touchAction: "none", fontFamily: "inherit" }}>
      ⠿
    </button>
  );
}
